const SDK_VERSION = '7.39.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
